import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAffirmationLoad, getJournalLoad, getTherapyload } from '../../../redux/slices/dash.slice';
import WhoCharts from './WhoCharts';

const baseOption = {
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [
      "day1", "day2", "day3", "day4", "day5",
      "day6", "day7", "day8", "day9", "day10",
      "day11", "day12", "day13", "day14", "day15",
      "day16", "day17", "day18", "day19", "day20",
      "day21", "day22", "day23", "day24", "day25",
      "day26", "day27", "day28", "day29", "day30", "day31"
    ],
  },
  yAxis: {
    type: "value",
    splitLine: false,
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "line",
      crossStyle: {
        color: "#999",
      },
    },
    formatter: function (params) {
      var result = "<strong>" + params[0].name + "</strong>";
      result += "<br/>" + params[0].data;
      return result;
    },
  },
  series: [
    {
      type: "line",
      stack: "line",
      areaStyle: {
        color: "#FFFFFF0D",
      },
      lineStyle: {
        width: 4,
        type: "solid",
      },
      showSymbol: false,
    },
  ],
};

const colors = ["#F16480", "#7C63A4", "#D4648A", "#D6A2BE"];

const processData = (data, month) => {
  const monthData = data || {}; // Ensure data is defined
  const days = [
    "day1", "day2", "day3", "day4", "day5",
    "day6", "day7", "day8", "day9", "day10",
    "day11", "day12", "day13", "day14", "day15",
    "day16", "day17", "day18", "day19", "day20",
    "day21", "day22", "day23", "day24", "day25",
    "day26", "day27", "day28", "day29", "day30", "day31"
  ];
  return days.map(day => monthData[day] || 0);
};

const WhoAllCharts = () => {
   
  const month = new Date().getMonth();
  const dispatch = useDispatch();
  const [affMonth ,setAffMonth] = useState(new Date().getMonth());
  const [journalMonth ,setJournalMonth] = useState(new Date().getMonth());
  const [therapyMonth , setTherapyMonth] = useState(new Date().getMonth());


  useEffect(() => {
    const myData = {
      month: month
    }
    dispatch(getAffirmationLoad(myData));
    dispatch(getJournalLoad(myData));
    dispatch(getTherapyload(myData));
  }, [month, dispatch]);
 
  const {affirmationData , journalData , therapyData }= useSelector((state) => state.dashboardReducer);

  if (!affirmationData || !journalData || !therapyData) {
    return <div>Data not found</div>;
  }

  const affirmationMonthChange = (value) => {
    const myMonth = {
      month : value
    }

    setAffMonth(value);
    
    dispatch(getAffirmationLoad(myMonth));
  };
 const JournalingMonthChange  = (value) => {

  const myMonth = {
    month : value
  }

  setJournalMonth(value);

  dispatch(getJournalLoad(myMonth));
  
  };

const TherapyMonthChange = (value) => {
  const myMonth = {
    month : value
  }
 setTherapyMonth(value);
  dispatch(getTherapyload(myMonth));
 }

  const chartOptions = [
    {
      ...baseOption,
      series: [{
        ...baseOption.series[0],
        data: processData(affirmationData, month),
        color : "#F16480"
      }],
    },
    {
      ...baseOption,
      series: [{
        ...baseOption.series[0],
        data: processData(journalData, month),
        color : "#7C63A4"
      }],
    },
    {
      ...baseOption,
      series: [{
        ...baseOption.series[0],
        data: processData(therapyData, month),
        color : "#D4648A"
      }],
    },
  ];

  return (
    <div>
      <div className="flex gap-4 lg:flex-col">
        <div className="w-[50%] lg:w-full">
          <WhoCharts
            text="Affirmation "
            month={affMonth}
            handleMonthChange={affirmationMonthChange}
            chartOptions={chartOptions[0]}
          />
        </div>
        <div className="w-[50%] lg:w-full">
          <WhoCharts
            text="Journaling"
            month={journalMonth}
            handleMonthChange={JournalingMonthChange}
            chartOptions={chartOptions[1]}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-4 lg:flex-col">
        <div className="w-[50%] lg:w-full">
          <WhoCharts
            text="Therapy"
            month={therapyMonth}
            handleMonthChange={TherapyMonthChange}
            chartOptions={chartOptions[2]}
          />
        </div>
      </div>
    </div>
  );
};

export default WhoAllCharts;
